// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .mat-mdc-text-field-wrapper {
  background-color: white !important;
  border-bottom: 2px solid white !important;
  padding-right: 0px;
}

::ng-deep .mat-mdc-form-field:hover .mat-mdc-text-field-wrapper,
::ng-deep .mat-mdc-form-field:hover .mat-mdc-form-field-flex {
  background-color: white !important;
}

::ng-deep .mat-mdc-form-field:hover .mat-mdc-form-field-focus-overlay {
  background-color: white !important;
}

::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: white !important;
}

::ng-deep .mat-mdc-form-field-focus-overlay {
  background-color: transparent !important;
}

.formField {
  width: 100%;
}

.secondary ::ng-deep {
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version. */
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version. */
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version. */
}
.secondary ::ng-deep .mat-mdc-form-field-flex {
  border: 2px solid rgba(233, 175, 81, 0.631372549);
  border-radius: 5px;
  height: 55px;
}
.secondary ::ng-deep .mat-mdc-form-field-infix {
  margin: 0;
  border: 0;
  padding: 16px;
}
.secondary ::ng-deep ::ng-deep .mdc-line-ripple {
  display: none !important;
}
.secondary ::ng-deep ::ng-deep .mat-mdc-text-field-wrapper {
  padding-right: 0px;
}
.secondary ::ng-deep ::ng-deep .mat-mdc-select-arrow {
  display: none !important;
}
.secondary ::ng-deep .mat-mdc-option .mdc-list-item {
  font-size: large !important;
}

.small ::ng-deep {
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version. */
}
.small ::ng-deep .mat-mdc-form-field-infix {
  margin: 0;
  border: 0;
  padding: 10px;
}
.small ::ng-deep ::ng-deep .mdc-line-ripple {
  display: none !important;
}
.small ::ng-deep ::ng-deep .mat-mdc-select-arrow {
  top: 6px;
}

.primary ::ng-deep .mat-mdc-form-field-flex {
  border: 2px solid rgba(233, 175, 81, 0.631372549);
  border-radius: 5px;
  height: 38px;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/shared/components/g-multiple-select/g-multiple-select.component.scss"],"names":[],"mappings":"AAEA;EACE,kCAAA;EACA,yCAAA;EACA,kBAAA;AADF;;AAIA;;EAEE,kCAAA;AADF;;AAIA;EACE,kCAAA;AADF;;AAIA;EACE,kCAAA;AADF;;AAIA;EACE,wCAAA;AADF;;AAIA;EACE,WAAA;AADF;;AAIE;EACE,iIAAA;EAMA,iIAAA;EAMA,iIAAA;AAXJ;AAAI;EACE,iDAAA;EACA,kBAAA;EACA,YAAA;AAEN;AACI;EACE,SAAA;EACA,SAAA;EACA,aAAA;AACN;AAEI;EACE,wBAAA;AAAN;AAEI;EACE,kBAAA;AAAN;AAGI;EACE,wBAAA;AADN;AAIE;EACE,2BAAA;AAFJ;;AAOE;EACE,iIAAA;AAJJ;AAKI;EACE,SAAA;EACA,SAAA;EACA,aAAA;AAHN;AAKI;EACE,wBAAA;AAHN;AAKI;EACE,QAAA;AAHN;;AASI;EACE,iDAAA;EACA,kBAAA;EACA,YAAA;AANN","sourcesContent":["@import \"/src/styles/_variables.scss\";\r\n\r\n::ng-deep .mat-mdc-text-field-wrapper {\r\n  background-color: white !important;\r\n  border-bottom: 2px solid white !important;\r\n  padding-right: 0px;\r\n \r\n}\r\n::ng-deep .mat-mdc-form-field:hover .mat-mdc-text-field-wrapper,\r\n::ng-deep .mat-mdc-form-field:hover .mat-mdc-form-field-flex {\r\n  background-color: white !important;\r\n}\r\n\r\n::ng-deep .mat-mdc-form-field:hover .mat-mdc-form-field-focus-overlay {\r\n  background-color: white !important;\r\n}\r\n\r\n::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) {\r\n  background-color: white !important;\r\n}\r\n\r\n::ng-deep .mat-mdc-form-field-focus-overlay {\r\n  background-color: transparent !important;\r\n}\r\n\r\n.formField {\r\n  width: 100%;\r\n}\r\n.secondary {\r\n  ::ng-deep {\r\n    /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version. */\r\n    .mat-mdc-form-field-flex {\r\n      border: 2px solid $secondary-color-light;\r\n      border-radius: 5px;\r\n      height: 55px;\r\n    }\r\n    /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version. */\r\n    .mat-mdc-form-field-infix {\r\n      margin: 0;\r\n      border: 0;\r\n      padding: 16px;\r\n    }\r\n    /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version. */\r\n    ::ng-deep .mdc-line-ripple {\r\n      display: none !important;\r\n    }\r\n    ::ng-deep .mat-mdc-text-field-wrapper {\r\n      padding-right: 0px;\r\n      \r\n    }\r\n    ::ng-deep .mat-mdc-select-arrow {\r\n      display: none !important;\r\n    }\r\n  }\r\n  ::ng-deep .mat-mdc-option .mdc-list-item {\r\n    font-size: large !important;\r\n  }\r\n}\r\n\r\n.small {\r\n  ::ng-deep {\r\n    /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version. */\r\n    .mat-mdc-form-field-infix {\r\n      margin: 0;\r\n      border: 0;\r\n      padding: 10px;\r\n    }\r\n    ::ng-deep .mdc-line-ripple {\r\n      display: none !important;\r\n    }\r\n    ::ng-deep .mat-mdc-select-arrow {\r\n      top: 6px;\r\n    }\r\n  }\r\n}\r\n.primary {\r\n  ::ng-deep {\r\n    .mat-mdc-form-field-flex {\r\n      border: 2px solid $secondary-color-light;\r\n      border-radius: 5px;\r\n      height: 38px;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
